module.exports = __webpack_public_path__ + "static/media/agendamento.3814d12d.png";